var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "container", staticClass: "vks-v2g-track" }, [
    _vm.methodLegendItems.length
      ? _c(
          "ul",
          {
            staticClass: "vks-v2g-method-legend",
            attrs: { "aria-label": _vm.legendAriaLabel },
          },
          _vm._l(_vm.methodLegendItems, function (item) {
            return _c(
              "li",
              {
                key: item.method,
                staticClass: "vks-v2g-method-legend-item",
                class: { "is-muted": item.muted },
              },
              [
                _c("span", {
                  staticClass: "vks-v2g-method-legend-swatch",
                  style: { backgroundColor: item.color },
                  attrs: { "aria-hidden": "true" },
                }),
                _c("span", [_vm._v(_vm._s(item.method))]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm.loadingTissue
      ? _c("div", { staticClass: "vks-v2g-track-status" }, [
          _vm._v(" " + _vm._s(_vm.loadingStatusText) + " "),
        ])
      : !_vm.hasRenderData
      ? _c("div", { staticClass: "vks-v2g-track-empty" }, [
          _vm._v(" " + _vm._s(_vm.emptyMessage) + " "),
        ])
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.hasRenderData,
            expression: "hasRenderData",
          },
        ],
        ref: "canvasWrap",
        staticClass: "vks-v2g-track-canvas-wrap",
      },
      [
        _c("canvas", {
          ref: "canvas",
          staticClass: "vks-v2g-track-canvas",
          class: {
            "is-pannable": _vm.canPan,
            "is-hover":
              Boolean(_vm.hoveredHit) && !_vm.isPanning && !_vm.xAxisBandHover,
            "is-x-axis-hover": _vm.xAxisBandHover,
          },
          on: {
            mousedown: _vm.onMouseDown,
            mousemove: _vm.onMouseMove,
            mouseout: _vm.onMouseOut,
            mouseup: _vm.onMouseUp,
            click: _vm.onCanvasClick,
          },
        }),
        _c("VariantSifterZoomCenterMarker", {
          attrs: {
            "region-view-area": _vm.regionViewArea,
            "region-zoom": _vm.regionZoom,
            "plot-margin": _vm.margin,
            placement: "track",
          },
          on: {
            "update:regionViewArea": function ($event) {
              return _vm.$emit("update:regionViewArea", $event)
            },
          },
        }),
      ],
      1
    ),
    _vm.hoveredHit
      ? _c(
          "div",
          {
            ref: "infoPanel",
            staticClass: "vks-v2g-track-info",
            attrs: { role: "status" },
          },
          [
            _c("p", { staticClass: "vks-v2g-track-info-title" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.hoveredHit.targetGene) +
                  " / " +
                  _vm._s(_vm.hoveredHit.method) +
                  " "
              ),
            ]),
            _c("p", { staticClass: "vks-v2g-track-info-row" }, [
              _c("span", { staticClass: "vks-v2g-track-info-label" }, [
                _vm._v("Tissue"),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.hoveredHit.tissue))]),
            ]),
            _c("p", { staticClass: "vks-v2g-track-info-row" }, [
              _c("span", { staticClass: "vks-v2g-track-info-label" }, [
                _vm._v("Biosample"),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.hoveredHit.biosample || "—"))]),
            ]),
            _c("p", { staticClass: "vks-v2g-track-info-row" }, [
              _c("span", { staticClass: "vks-v2g-track-info-label" }, [
                _vm._v("Regulatory element"),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.hoveredHit.start) +
                    "–" +
                    _vm._s(_vm.hoveredHit.end)
                ),
              ]),
            ]),
            _c("p", { staticClass: "vks-v2g-track-info-row" }, [
              _c("span", { staticClass: "vks-v2g-track-info-label" }, [
                _vm._v("Promoter"),
              ]),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm.hoveredHit.targetGeneStart) +
                    "–" +
                    _vm._s(_vm.hoveredHit.targetGeneEnd) +
                    " "
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }